var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dropdown" }, [
    _c(
      "button",
      {
        ref: "button",
        staticClass: "nav dropdown__expand-btn",
        class: _vm.expanded && "is-open",
        attrs: { type: "button", "data-testid": "dropdown-list-button" },
        on: { click: _vm.onClick }
      },
      [
        _c("span", { staticClass: "dropdown__text" }, [
          _vm._v(_vm._s(_vm.selectedText))
        ]),
        _c("i", { staticClass: "icon icon-arrow_down_filled" })
      ]
    ),
    _vm.expanded
      ? _c(
          "ul",
          { staticClass: "dropdown__list" },
          [
            _vm._l(_vm.options, function(option) {
              return [
                _c(
                  "li",
                  {
                    key: option.value,
                    ref: `li${option.value}`,
                    refInFor: true,
                    staticClass: "dropdown__list-item",
                    class: [
                      "dropdown-list__item",
                      _vm.selected == option.value ? "is-active" : ""
                    ],
                    attrs: { "data-value": option.value },
                    on: {
                      click: function($event) {
                        return _vm.onSelect(option)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(option.text) + " ")]
                ),
                option.hasDivider
                  ? _c(
                      "li",
                      { key: option.value, staticClass: "dropdown__divider" },
                      [_c("hr", { staticClass: "dropdown__divider-line" })]
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }